export default {
  cashback: {
    enabled: 'Points applied successfully',
  },
};
